<template>
  <el-popover v-model="visible" placement="bottom-start" :width="innerWidth" trigger="click" popper-class="elpopper">
    <div class="simple-list">
      <div class="simple-item" v-for="(item, index) in items" :key="index" @click="handleClick(item)">
        {{ item.text }}
      </div>
    </div>
    <template v-slot:reference>
      <div ref="referenceSlot">
        <slot name="reference">
          <div class="default-trigger">{{ referenceText }}</div>
        </slot>
      </div>
    </template>
  </el-popover>
</template>

<script>
export default {
  props: {
    referenceText: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    onSelect: {
      type: Function,
      default: null
    },
  },
  data() {
    return {
      visible: false,
      innerWidth: 100
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          const el = this.$refs.referenceSlot
          if (el) {
            this.innerWidth = el.offsetWidth
          }
        })
      }
    }
  },
  methods: {
    handleClick(item) {
      this.$emit('select', item)
      if (this.onSelect) this.onSelect(item)
      this.visible = false
    }
  }
}
</script>

<style scoped>
.simple-list {
  display: flex;
  flex-direction: column;
  background: var(--info_color);
  border-radius: 0 0 10px 10px;

  .simple-item {
    padding: 15px;
    cursor: pointer;
    font-size: 15px;
    font-weight: bold;
    color: var(--text_color);
  }

  .simple-item:hover {
    background: var(--select_info_color);
  }
}

.default-trigger {
  cursor: pointer;
  padding: 6px 10px;
  background-color: #f2f2f2;
  border-radius: 4px;
  display: inline-block;
}
</style>
